import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import Box from '@atlaskit/primitives/box';
// oxlint-disable-next-line @atlaskit/design-system/no-emotion-primitives
import { xcss } from '@atlaskit/primitives/xcss';
import IconButton from '@atlaskit/button/icon/button';

import { useLoomEntryPointVariant } from '@confluence/loom-utils/entry-points/useLoomEntryPointVariant.ts';

import { LoomVideoIcon } from './VideoIcon.tsx';

const buttonSpacerStyles = xcss({
	minWidth: '30px',
});

export const LoomPageHeaderPlaceholder = ({
	isCircle,
	isEnabled,
}: {
	isCircle?: boolean;
	isEnabled?: boolean;
}): React.JSX.Element | null => {
	const { entryPointVariant } = useLoomEntryPointVariant();

	if (entryPointVariant === 'DISABLED') {
		return null;
	} else {
		return (
			<Box xcss={buttonSpacerStyles}>
				<IconButton
					appearance="subtle"
					shape={isCircle ? 'circle' : 'default'}
					icon={LoomVideoIcon}
					testId="page-header-loom-entry-point-loading-icon"
					data-vc="loom-button"
					isDisabled={!isEnabled}
					label="Record a Loom video"
				/>
			</Box>
		);
	}
};
